import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IOrganisation } from '@bciti/types';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';

@Component({
    selector: 'app-user-import',
    templateUrl: './user-import.component.html',
    styleUrls: ['./user-import.component.scss'],
})
export class UserImportComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    breadcrumb: IBreadcrumbItem[] = [
        {
            link: '/organisations',
            title: 'Organisations',
        },
        {
            link: '',
            title: 'User import',
        },
    ];

    org: IOrganisation;
    tag: string;

    get getTitle(): string {
        return `${this.org ? this.org.name : this.tag}: user import`;
    }

    constructor(private route: ActivatedRoute, private organisationService: OrganisationService) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            console.log(param);
            if (param.tag) {
                this.tag = param.tag;
                this.organisationService
                    .getOrganisationByTag(param.tag)
                    .pipe(
                        takeUntil(this.destroy$),
                        tap((org) => (this.org = org)),
                    )
                    .subscribe();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
